import { spacing, color } from '@upstox/upstox-ui';

export const timeLineCardContainer: CSSFunction = ({ theme }) => ({
  backgroundColor: color(theme, 'text.3'),
  padding: spacing(theme, [16]),
});

export const timeLineContainer: CSSFunction = ({ theme }) => ({
  flexDirection: 'row',
  marginTop: spacing(theme, [32]),
  '@media (min-width:768px)': {
    marginTop: spacing(theme, [16]),
    flexDirection: 'column',
  },
});

export const timelineItemWrapper: CSSFunction = ({ theme }) => ({
  width: '100%',
  flexDirection: 'column',
  marginLeft: spacing(theme, [24]),
  '@media (min-width:768px)': {
    flexDirection: 'row',
    marginLeft: spacing(theme, [0]),
    marginTop: spacing(theme, [32]),
  },
  '@media (min-width:576px)': {
    paddingRight: spacing(theme, ['xlarge']),
  },
});

export const timelineItemHeader: CSSFunction = ({ theme }) => ({
  width: '100%',
  height: '100%',
  '@media (min-width:768px)': {
    width: 90,
    height: 40,
  },
  marginBottom: spacing(theme, [16]),
});

export const timelineWrapper: CSSFunction = ({ theme }) => ({
  width: 325,
  '@media (min-width:576px)': {
    width: 432,
    paddingRight: spacing(theme, ['xlarge']),
  },
});

export const divider: CSSFunction = ({ theme }) => ({
  margin: spacing(theme, [14, 'none']),
});

export const statusIcon: CSSFunction = ({ theme }) => ({
  marginRight: spacing(theme, ['small']),
});

export const timelineItem: CSSFunction = ({ theme }) => ({
  marginBottom: spacing(theme, ['medium']),
  width: '100%',
});

export const notes: CSSFunction = ({ theme }) => ({
  marginTop: spacing(theme, ['xsmall']),
});
